var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#3A92E5",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus_link_svg__clip0_2600_17818)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2 1.2v5.6h5.6c.656 0 1.2.544 1.2 1.2 0 .656-.544 1.2-1.2 1.2H9.2v5.6c0 .656-.544 1.2-1.2 1.2-.656 0-1.2-.544-1.2-1.2V9.2H1.2C.544 9.2 0 8.656 0 8c0-.656.544-1.2 1.2-1.2h5.6V1.2C6.8.544 7.344 0 8 0c.656 0 1.2.544 1.2 1.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus_link_svg__clip0_2600_17818"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgPlusLink;